/**
 * Recharts styling that follows the active theme. Values are CSS variables, so
 * charts re-theme without re-rendering. Pass these straight into Recharts props.
 */
export const chartColors = {
  primary: 'var(--theme-chart-primary)',
  dot: 'var(--theme-chart-dot)',
  grid: 'var(--theme-chart-grid)',
  text: 'var(--theme-text-muted)',
  success: 'var(--theme-success)',
  loss: 'var(--theme-loss)',
  be: 'var(--theme-break-even)',
  gradientStart: 'var(--theme-chart-gradient-start)',
  gradientEnd: 'var(--theme-chart-gradient-end)',
};

export const chartAxisProps = {
  stroke: 'var(--theme-chart-grid)',
  tick: { fill: 'var(--theme-text-muted)', fontSize: 11 },
  tickLine: false,
  axisLine: false,
};

export const chartGridProps = {
  stroke: 'var(--theme-chart-grid)',
  strokeDasharray: '3 3',
  vertical: false,
};

export const chartTooltipProps = {
  contentStyle: {
    background: 'var(--theme-chart-tooltip-bg)',
    border: '1px solid var(--theme-border)',
    borderRadius: 10,
    color: 'var(--theme-text)',
    fontSize: 12,
    boxShadow: '0 8px 24px var(--theme-shadow)',
  },
  labelStyle: { color: 'var(--theme-text-muted)', marginBottom: 4 },
  itemStyle: { color: 'var(--theme-text)' },
  cursor: { stroke: 'var(--theme-border)', fill: 'var(--theme-accent-soft)' },
};

/** Read a resolved theme colour (for canvas/SVG code that can't use CSS vars). */
export function readThemeColor(name, fallback = '#888888') {
  if (typeof window === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(`--theme-${name}`).trim();
  return value || fallback;
}
